import axiosInstance from '../configs/axios/interceptors';
import { handleDateConvertForApis } from '../utils/functions';

const DocumentsServices = {

    getDocumentsList: async (filters) => {
        const response = await axiosInstance.get('Document/GetDocumentsList', { params: filters });
        return response.data;
    },

    getSelectedDocumentsList: async (payload) => {
        const bodyData = {
            ...payload,
            dateAddedFrom: payload.dateAddedFrom
                ? handleDateConvertForApis(payload.dateAddedFrom)
                : undefined,
            dateAddedTo: payload.dateAddedTo
                ? handleDateConvertForApis(payload.dateAddedTo)
                : undefined,
            lastUpdatedDateFrom: payload.lastUpdatedDateFrom
                ? handleDateConvertForApis(payload.lastUpdatedDateFrom)
                : undefined,
            lastUpdatedDateTo: payload.lastUpdatedDateTo
                ? handleDateConvertForApis(payload.lastUpdatedDateTo)
                : undefined,
            docIDList: payload.docIDList
                ? payload.docIDList
                : undefined,
        };

        const cleanBody = Object.fromEntries(
            Object.entries(bodyData).filter(([_, v]) => v != null)
        );

        const response = await axiosInstance.post('Document/GetDocumentsListExport', cleanBody);
        return response.data;
    },

    getDocumentListAttachments: async (payload) => {
        const bodyData = {
            ...payload,
            dateAddedFrom: payload.dateAddedFrom
                ? handleDateConvertForApis(payload.dateAddedFrom)
                : undefined,
            dateAddedTo: payload.dateAddedTo
                ? handleDateConvertForApis(payload.dateAddedTo)
                : undefined,
            lastUpdatedDateFrom: payload.lastUpdatedDateFrom
                ? handleDateConvertForApis(payload.lastUpdatedDateFrom)
                : undefined,
            lastUpdatedDateTo: payload.lastUpdatedDateTo
                ? handleDateConvertForApis(payload.lastUpdatedDateTo)
                : undefined,
            docIDList: payload.docIDList
                ? payload.docIDList
                : undefined,
        };

        const cleanBody = Object.fromEntries(
            Object.entries(bodyData).filter(([_, v]) => v != null)
        );

        const response = await axiosInstance.post('Document/GetDocumentListAttachments', cleanBody);
        return response.data;
    },

    // getDocumentListAttachments: async (payload) => {
    //     const params = {}
    //     const bodyData = {
    //         docIDList: payload.docIDList,
    //         sortColumn: payload.sortColumn,
    //         userID: payload.userID
    //     };
    //     const response = await axiosInstance.post('Document/GetDocumentListAttachments',
    //         bodyData,
    //         {
    //             params: params
    //         });

    //     // const response = await axiosInstance.post('Document/GetDocumentListAttachments', { params: filters });
    //     return response.data;
    // },


    getDocument: async (documentId, userId) => {
        const params = { documentId, userId };

        const response = await axiosInstance.get('Document/GetDocumentDetails', { params: params });
        return response.data;
    },

    updateDocument: async (values) => {
        const payload = {
            Document: {
                ID: values.DocumentID, // Fix the ID field
                Flux: values.Flux,
                Plate: values.Plate,
                DivisionID: values.DivisionID || null,
                AnomalyID: values.AnomalyID || null,
                SupplierID: values.SupplierID || null,
                TypeID: values.TypeID || null,
                Year: values.Year || null,
                Notes: values.Notes || null,
                LastEditedUser: values.LastEditedUser || null,
                DateAdded: values.DateAdded
                    ? new Date(values.DateAdded).toISOString() // Ensure correct date format
                    : null
            }
        };
        const response = await axiosInstance.put('Document/UpdateDocument', payload);
        return response.data;
    },

    addDocument: async (payload) => {

        const response = await axiosInstance.post('Document/AddDocument', payload, { params: payload });
        return response.data;
    },

    deleteDocument: async (documentId) => {
        const params = { documentId };

        const response = await axiosInstance.delete('Document/RemoveDocument', { params: params });
        return response.data;
    },

    addDocumentNote: async (payload) => {
        const params = { "documentID": payload.documentID, "note": payload.note, "userID": payload.userID };
        const response = await axiosInstance.post('Document/AddDocumentNote', payload, { params: params });
        return response.data;
    },

    getDocumentNotes: async (documentId) => {
        const params = { documentId };

        const response = await axiosInstance.get('Document/GetDocumentNotes', { params: params });
        return response.data;
    },

    getDocumentAttachments: async (documentId) => {
        const params = { documentId };

        const response = await axiosInstance.get('Attachment/GetAttachments', { params: params });
        return response.data;
    },

    addDocumentAttachment: async (payload) => {
        const response = await axiosInstance.post('Attachment/UploadFile', payload);
        return response.data;
    },

    removeDocumentAtachment: async (attachmentId, userId) => {
        const params = { attachmentId, userId };

        const response = await axiosInstance.delete('Attachment/DeleteAttachment', { params: params });
        return response.data;
    },

    readDocumentPDF: async (documentId) => {
        const params = { documentId: documentId };
        const response = await axiosInstance.get('Attachment/ReadPDF', { params: params });
        return response.data;
    },

    getDocumentType: async (docName) => {
        const params = { docName };

        const response = await axiosInstance.get('DocumentTypes/GetDocumentTypes', { params: params });
        return response.data;
    },

    getDocumentTypeDistinte: async () => {
        const response = await axiosInstance.get('Document_Distinte/GetDocumentTypeDistinte');
        return response.data;
    },

    getDocumentStatus: async (statusName) => {
        const params = { statusName };
        const response = await axiosInstance.get('DocumentTypes/GetDocumentWorkingStatuses', { params: params });
        return response.data;
    },

    registerDocument: async (payload) => {
        const params = {
            documentID: payload.documentID,
            userID: payload.userID,
            anomalyID: payload.anomalyID
        };
        const response = await axiosInstance.put('Document/RegisterDocument', payload, { params: params });
        return response.data;
    },

    addDocumentFlux: async (payload) => {
        const response = await axiosInstance.post('DocumentFlux/UploadDocumentFlux', payload);
        return response.data;
    },

    documentInSospeso: async (payload) => {
        const params = {
            documentID: payload.documentID,
            userID: payload.userID,
            anomalyID: payload.anomalyID
        };
        const response = await axiosInstance.put('Document/DocumentInSospeso', params, { params: params });
        return response.data;
    },

    removeDocumentNote: async (noteId) => {
        const params = { documentNoteID: noteId };

        const response = await axiosInstance.delete('Document/RemoveDocumentNote', { params: params });
        return response.data;
    },

    handelNonCompetenza: async (payload) => {
        const params = {
            documentID: payload.documentID,
            userID: payload.userID,
        };
        const response = await axiosInstance.put('Document/DocumentoNonDiCompetenza', payload, { params: params });
        return response.data;
    }

};

export default DocumentsServices;